import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  onDeleteFile: () => void
  file: File
  defaultName: string
  renderIcon?: (file: File) => React.ReactNode
  error?: string
}

const Item = ({ file, onDeleteFile, defaultName, renderIcon, error = undefined }: Props) => {
  const defaultIcon = error ? 'alert-circle' : 'file'

  const defaultIconColor = error ? 'radicalRed1000' : undefined

  const buttonType = error ? 'primary' : 'secondary'

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      gap="s16"
      paddingY="s12"
      paddingX="s16"
      width="full"
      style={{ minWidth: '0' }}
    >
      <Box style={{ flexShrink: '0', flexGrow: '0' }}>
        {!renderIcon && <Icon.Medium icon={defaultIcon} color={defaultIconColor} />}
        {renderIcon && renderIcon(file)}
      </Box>
      <Box flexGrow overflowX="hidden" style={{ minWidth: '0', flexShrink: '1', width: '0' }}>
        <Text size="200" weight="normal" ellipsis overflowWrap>
          {file.name || defaultName}
        </Text>
      </Box>
      <Box style={{ flexShrink: '0', flexGrow: '0' }}>
        <Button type={buttonType} onClick={() => onDeleteFile()} iconName="delete" />
      </Box>
    </Box>
  )
}

export default observer(Item)
